import ReactModal from "react-modal";
import React, { useState } from "react";
import styled from "styled-components";
import Close from "./images/close.svg";
import "./Ces.css";
import BgR from "./images/popupBg.png";
import { P } from "../CommonStyle";
import Tick from "./images/tick.svg";
import TickG from "./images/greenTick.svg";
import { userTrack } from "../Common";
import Image from "next/image";

const PopupWrap = styled.div`
  position: relative;
  min-height: 200px;
  background: #fff;
  margin: 0 auto;
  height: auto !important;
  overflow: hidden !important;
  border-radius: 11px;
  border: none;
  outline: none;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 767px) {
    width: auto !important;
    padding: 0 15px;
    display: initial;
  }
`;
const CloseImg = styled.div`
  float: right;
  padding: 14px;
  position: absolute;
  right: 10px;
  top: 3px;
  &:hover {
    cursor: pointer;
  }
  @media screen and (max-width: 767px) {
    padding: 7px;
    right: 10px;
    top: -17px;
  }
`;

const BannerLeft = styled.div`
  background-image: url(${BgR.src});
  background-size: cover;
  background-repeat: no-repeat;
  height: 590px;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;
const ContentRWrap = styled.div`
  padding: 0 60px;
  padding-top: 20px;
`;
const ListWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 35px;
`;
const TickImg = styled.div`
  margin-top: 8px;
`;
const ListContent = styled.div`
  color: #fff;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.4px;
`;
const BannerRight = styled.div`
  padding: 50px 60px;
  text-align: center;

  @media screen and (max-width: 767px) {
    padding: 15px 20px;
  }
`;
const ButtonWrapDwn = styled.div`
  margin-top: 30px;
  margin-bottom: 60px;
`;
const DwnldBtn = styled.div`
  background-color: #ff7624;
  border-radius: 10px;
  padding: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  width: 90px;
  margin: 0 auto;
  cursor: pointer;

  &:hover {
    background-color: #cd5900;
  }

  @media screen and (max-width: 767px) {
  }
`;

const DwnldBtnTxt = styled.p`
  margin: 0;
  color: #fff;
  font-family: Roboto;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;

  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;
const GTickImg = styled.div``;

const SubscribeEmail = (props) => {
  const [isOpen, setisOpen] = useState(true);
  const handleClose = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on " Got it`,
      "2024 download Form - Popup"
    );
    props.show(false);
    props.setShowSub(false);
  };

  return (
    <div>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={() => handleClose()}
        ariaHideApp={false}
        className="modal-popup-SubPopUp"
      >
        <PopupWrap>
          <div>
            <BannerLeft>
              <ContentRWrap>
                <P
                  text="Ideapoke CES 2025"
                  color="#fff"
                  fontSize="32px"
                  fontWeight="700"
                  letterSpacing="0.4px"
                ></P>
                <P
                  text="Trends & Innovations Report Report"
                  color="#fff"
                  fontSize="24px"
                  fontWeight="700"
                  letterSpacing="0.4px"
                ></P>
                <div>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Get hints on emerging business opportunities you may be
                      missing
                    </ListContent>
                  </ListWrap>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Understand Impact of Disrupting Technologies
                    </ListContent>
                  </ListWrap>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>Identify Market Shifts early on</ListContent>
                  </ListWrap>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Spot potential partners, customers, investment
                      opportunities
                    </ListContent>
                  </ListWrap>
                </div>
              </ContentRWrap>
            </BannerLeft>
          </div>

          <div style={{ position: "relative" }}>
            <CloseImg onClick={() => handleClose()}>
              <Image src={Close} alt="Close" />
            </CloseImg>
            <BannerRight>
              <GTickImg>
                <Image src={TickG} alt="TickG" />
              </GTickImg>
              <P
                text="You have already subscribed to the Ideapoke CES 2025 report."
                textAlign="left"
                color="#454545"
                fontSize="20px"
                fontWeight="600"
                mobFontSize="18px"
                MobtextAlign="center"
              ></P>
              <ButtonWrapDwn onClick={handleClose}>
                <DwnldBtn>
                  <DwnldBtnTxt>Got it!</DwnldBtnTxt>
                </DwnldBtn>
              </ButtonWrapDwn>
            </BannerRight>
          </div>
        </PopupWrap>
      </ReactModal>
    </div>
  );
};

export default SubscribeEmail;
